var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPath1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 395.328 883.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "maskPath",
    d: "M2667.667,7325.869c-150.68,445.4,165.078,497.172,154.338,628.091-10.223,124.614-87.166,187.481-142.2,216.616-112.782,59.7-249.106,23.709-249.106,23.709",
    transform: "translate(-2429.93 -7324.907)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "maskReveal",
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M2667.667,7325.869c-150.68,445.4,165.078,497.172,154.338,628.091-10.223,124.614-87.166,187.481-142.2,216.616-112.782,59.7-249.106,23.709-249.106,23.709",
    transform: "translate(-2429.93 -7324.907)",
    fill: "none",
    stroke: "#ff4b4b",
    strokeWidth: 6,
    strokeDasharray: "8 5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath1);
export default __webpack_public_path__ + "static/media/path-1.812a38f8.svg";
export { ForwardRef as ReactComponent };